export const MenuItems = [
  {
    title:"Home",
    url:"/",
    cName:"nav-links",
    icon:"fa-sharp fa-solid fa-house"
  },
  {
    title:"About",
    url:"/about",
    cName:"nav-links",
    icon:" fa-solid fa-circle-info"
  },
  {
    title:"Service",
    url:"/service",
    cName:"nav-links",
    icon:" fa-solid fa-house-user"
  },
  {
    title:"Contact",
    url:"/contact",
    cName:"nav-links",
    icon:" fa-solid fa-address-book"
  },
  {
    title:"Login",
    url:"/login",
    cName:"nav-links",
  }
  
];
